import * as Yup from "yup";
import { APP_CONFIG } from "../../constants/constants";

export type TFormFieldNames = "current_password" | "new_password" | "confirm_new_password";
export const formInitialValues = {
  current_password: "",
  new_password: "",
  confirm_new_password: "",
};

const PASSWORD_SPECIAL_CHARACTERS = APP_CONFIG.PASSWORD.SPECIAL_CHARACTERS;
const PASSWORD_REGEX = new RegExp(
  `^(?=.*[${PASSWORD_SPECIAL_CHARACTERS.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")}])[a-zA-Z0-9${PASSWORD_SPECIAL_CHARACTERS.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")}]{${APP_CONFIG.PASSWORD.MIN_LENGTH},${APP_CONFIG.PASSWORD.MAX_LENGTH}}$`
);

export const YupValidationSchema = Yup.object().shape({
  // current_password: Yup.string()
  //   .required("Current password is required")
  //   .min(APP_CONFIG.PASSWORD.MIN_LENGTH, `Password is too short - should be minimum ${APP_CONFIG.PASSWORD.MIN_LENGTH} chars`),
  current_password: Yup.string()
    .required("Current password is required"),


  // new_password: Yup.string()
  //   .required("New password is required")
  //   .min(APP_CONFIG.PASSWORD.MIN_LENGTH, `Password is too short - should be minimum ${APP_CONFIG.PASSWORD.MIN_LENGTH} chars`),
  new_password: Yup.string()
    .required("New password is required")
    .min(
      APP_CONFIG.PASSWORD.MIN_LENGTH,
      `Password is too short - should be minimum ${APP_CONFIG.PASSWORD.MIN_LENGTH} chars`
    )
    .max(
      APP_CONFIG.PASSWORD.MAX_LENGTH,
      `Password is too long - should be maximum ${APP_CONFIG.PASSWORD.MAX_LENGTH} chars`
    )
    .matches(
      PASSWORD_REGEX,
      `Password must contain at least one special character from: ${APP_CONFIG.PASSWORD.SPECIAL_CHARACTERS}`
    ),

  confirm_new_password: Yup.string()
    .required("Please enter your new password again to confirm it")
    .oneOf([Yup.ref('new_password')], 'Passwords must match'),

});